var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('img',{attrs:{"src":require("@/assets/zanwushuju-2@2x.png"),"height":"177","width":"177"}}),_c('div',{staticClass:"nodatatext"},[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }